"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arbitraryModelAsset = void 0;
exports.arbitraryNewDocumentData = arbitraryNewDocumentData;
exports.arbitrarySearchDocumentData = arbitrarySearchDocumentData;
exports.arbitraryNewDocument = arbitraryNewDocument;
const tslib_1 = require("tslib");
const constants_1 = require("@buildwithflux/constants");
const fast_check_1 = tslib_1.__importDefault(require("fast-check"));
const src_1 = require("../../src");
const document_1 = require("../../src/document");
const element_1 = require("./element");
const property_1 = require("./property");
const user_1 = require("./user");
/**
 * Generate an arbitrary model asset.
 */
exports.arbitraryModelAsset = fast_check_1.default.record({
    uid: fast_check_1.default.uuid(),
    name: fast_check_1.default.string(),
    rawName: fast_check_1.default.string(),
    storageName: fast_check_1.default.string(),
    label: fast_check_1.default.string(),
    fileType: fast_check_1.default.constantFrom("step", "stp", "gltf"),
    isDefault: fast_check_1.default.constantFrom(false),
    isThumbnail: fast_check_1.default.constantFrom(false),
    isFootprint: fast_check_1.default.constantFrom(false),
    // NOTE: this is intentionally a boolean and not true!  The flag is3dModel is actually an input
    // from the user and not determined by us.  So a "legit" 3d model node could actually have a falsy
    // value for this field!
    is3dModel: fast_check_1.default.boolean(),
    isPcbBoardShape: fast_check_1.default.constantFrom(false),
});
/**
 * Create a new document with arbitrary initialization parameters.
 */
function arbitraryNewDocumentData(constraints = {}) {
    return fast_check_1.default
        .record({
        user: constraints.user ? fast_check_1.default.constant(constraints.user) : (0, user_1.arbitraryNonAnonymousUser)(),
        organization: constraints.organization ? fast_check_1.default.constant(constraints.organization) : fast_check_1.default.constant(undefined),
        enterprise: constraints.enterprise ? fast_check_1.default.constant(constraints.enterprise) : fast_check_1.default.constant(undefined),
        description: constraints.description ? fast_check_1.default.constant(constraints.description) : fast_check_1.default.lorem(),
        behavior: constraints.behavior ? fast_check_1.default.constant(constraints.behavior) : fast_check_1.default.lorem(),
        properties: constraints.properties ? fast_check_1.default.constant(constraints.properties) : property_1.arbitraryPropertiesMap,
        elements: constraints.elements ? fast_check_1.default.constant(constraints.elements) : (0, element_1.arbitraryElementsMap)(),
        pcbLayoutNodes: constraints.pcbLayoutNodes
            ? fast_check_1.default.constant(constraints.pcbLayoutNodes)
            : fast_check_1.default.constant(undefined),
        pcbLayoutRuleSets: constraints.pcbLayoutRuleSets
            ? fast_check_1.default.constant(constraints.pcbLayoutRuleSets)
            : fast_check_1.default.constant(undefined),
        hasCustomName: constraints.hasCustomName ? fast_check_1.default.constant(constraints.hasCustomName) : fast_check_1.default.boolean(),
    })
        .map(({ user, organization, enterprise, description, behavior, properties, elements, pcbLayoutNodes, pcbLayoutRuleSets, hasCustomName, }) => {
        const doc = (0, document_1.createNewDocumentData)(user, organization, enterprise, description, behavior);
        doc.has_custom_name = hasCustomName;
        doc["properties"] = properties;
        doc["elements"] = elements;
        if (pcbLayoutNodes != null) {
            doc["pcbLayoutNodes"] = pcbLayoutNodes;
        }
        if (pcbLayoutRuleSets != null) {
            doc["pcbLayoutRuleSets"] = pcbLayoutRuleSets;
        }
        if (constraints.slug) {
            doc.slug = constraints.slug;
        }
        return doc;
    });
}
function arbitrarySearchDocumentData(constraints = {}) {
    return arbitraryNewDocumentData(constraints).chain((documentData) => {
        const userAccessList = (0, src_1.generateUserAccessListForDocument)(documentData, []);
        return fast_check_1.default
            .record({
            objectID: fast_check_1.default.uuid(),
            contributor_uids: fast_check_1.default.array(fast_check_1.default.uuid(), { minLength: 1 }),
        })
            .map(({ objectID, contributor_uids }) => {
            return {
                ...documentData,
                objectID,
                contributor_uids,
                is_published: !!documentData.belongs_to_part_uid,
                partUid: documentData.belongs_to_part_uid,
                is_organization_owned: !!documentData.organization_owner_uid,
                test_data: true,
                userAccessList,
                anyoneCanView: userAccessList.includes(constants_1.ANON_ROLE_UID),
                fork_count: documentData.fork_count ?? 0,
                star_count: documentData.star_count ?? 0,
                comment_count: documentData.comment_count ?? 0,
                usage_count: documentData.usage_count ?? 0,
                copy_count: documentData.copy_count ?? 0,
            };
        });
    });
}
function arbitraryNewDocument(constraints = {}, metadataGenerator = new document_1.MockMetadataGenerator()) {
    return fast_check_1.default.record({
        documentData: arbitraryNewDocumentData(constraints).map((documentData) => (0, document_1.intoBaseDocument)(documentData)),
        metadata: fast_check_1.default.constant(metadataGenerator.generate("baseDocument")),
    });
}
//# sourceMappingURL=document.js.map